import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ATableColumnGroup',
    slots: Object,
    __ANT_TABLE_COLUMN_GROUP: true,
    render() {
        return null;
    },
});
